import React from 'react';
import { BasicModal as Modal } from '@luxe/components';

export const RiskDescriptionModal = ({ visible, onCancel, risk }) => (
  <Modal forceRender footer={null} open={visible} onCancel={onCancel} style={{ color: 'white' }}>
    {risk ? (
      <div style={{ fontWeight: 600, fontSize: '13px' }}>
        <div style={{ fontSize: '24px', color: 'white', marginBottom: '24px' }}>{risk.risk_type.name}</div>

        <div style={{ display: 'flex' }}>
          <div
            style={{
              border: '2px solid #FFFFFF17',
              backgroundColor: '#3F434D',
              display: 'flex',
              borderRadius: '6px',
              padding: '3px',
              marginBottom: '24px',
            }}
          >
            {risk.risk_category.name} &gt; {risk.risk_sub_category.name}
          </div>
        </div>

        <div style={{ marginBottom: '12px' }}>DEFINITION</div>
        <div style={{ color: '#A9AEB8', marginBottom: '24px' }}>{risk.definition}</div>

        <div style={{ marginBottom: '12px' }}>SEVERITY LEVELS</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#282C36',
            border: '2px solid #3F434D',
            borderRadius: '6px',
            gap: '24px',
            padding: '12px',
          }}
        >
          {['minor', 'moderate', 'severe', 'extreme']
            .filter(s => risk[s] !== 'N/A')
            .map(severity => (
              <div key={severity} style={{ display: 'grid', gridTemplateColumns: '1fr 4fr', gap: '12px' }}>
                <div>
                  <div
                    style={{
                      border: '2px solid #FFFFFF17',
                      borderRadius: '6px',
                      color: 'white',
                      fontSize: '12px',
                      height: 'auto',
                      display: 'flex',
                      backgroundColor: '#3F434C',
                      padding: '4px 5px',
                      alignItem: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {severity.toUpperCase()}
                  </div>
                </div>
                <div style={{ color: '#A9AEB8' }}>{risk[severity]}</div>
              </div>
            ))}
        </div>
      </div>
    ) : (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: '#A9AEB8' }}>Risk data not available</div>
      </div>
    )}
  </Modal>
);
